import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/recentSearches/useRecentSearchQueryKeys.ts
var t = e("recentSearches", { list: (e) => e ? ["list", e] : ["list"] });
//#endregion
export { t as recentSearchQueryKeys };
